import React, { Component } from "react";
import { Trans } from "react-i18next";
import ls from "local-storage";
import { options } from "../../config/options";
import Confetti from "react-confetti";

import SideNav from "react-simple-sidenav";
import { NavLink } from "react-router-dom";
import SideBar from "../main/SideBar";
import Countdown from "./Countdown";
// import Footer from "../main/Footer";
import PropTypes from "prop-types";
import Slider from "react-slick";
import axios from "axios";
import Swiper from "react-id-swiper";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
// import { GoogleComponent } from 'react-google-location';
import Autocomplete from "react-google-autocomplete";

// import $ from 'jquery';
import Boost from "../main/Boost";
import "../../config/i18n";
import { withTranslation } from "react-i18next";
import { CAPTURE_EVENT } from "../../Services/PosthogService";
import { userSend } from "../../Services/ActivityServices";

const API_KEY = "AIzaSyB0XIn1TilBdvJcpfaBPAilXK1HLznLMaQ";

const Card = ({ property }) => {};

Card.propTypes = {
  property: PropTypes.object.isRequired,
};

class PeopleNear extends Component {
  constructor(props) {
    super(props);
    this.loggedIn = sessionStorage.getItem("loggedin");
    this.onSubmitlocationsearch = this.onSubmitlocationsearch.bind(this);
    this.homeLink = this.homeLink.bind(this);
    this.getUserById = this.getUserById.bind(this);
    this.state = {
      showNav3: false,
      locationerr: "",
      peoples: "",
      change_loc: "none",
      change_loc2: "none",
      property: "",
      api_url: localStorage.getItem("api_url"),
      newindex: "",
      liked: "",
      nope: "",
      like_txt: "",
      nope_txt: "",
      hide: "",
      appholder1: "appHolder",
      appholder2: "none",
      user_details: "",
      modal1: false,
      modal2: false,
      modal10: false,
      modal22: false,
      backdrop: true,
      modal11: false,
      superlike_txt: "",
      like: "like",
      premmodal4: false,
      superlike: "superlike",
      profile_userid: "ghjgjh",
      permium_superlikeCount: 0,
      permium_boostCount: 0,
      lang: ls.get("LangKeySet") || options[0],
      langKey: ls.get("LangValue"),
      free_premium_enabled: false,
      free_premium_days: 0,
      superlikeItems: [],
      matches: "",
      superlikeCount: 0,
      superlikePlanStatus: 0,
      selected_superlikepremium: "",
      remainaing_hours: "",
      start_date: "",
      end_date: "",
      total_hours: "",
      like_status: "",
      timer_status: 0,
      superlikepremium_price: "",
      referred_login_msg_modal: false,
      referred_login_message: "",
      imagess: [],
      itemss: [],
      activeItems: "",
      user_id: "",
      place: null,
      lat: null,
      lon: null,
      selected_premium: "",
      width: 500,
      height: 600,
      totallikecount: 0,
      currency: "",
      payment: "",
      license_key: "",
      premium_price: "",
      undo: "1",
      undostatus: "true",
      tmp_image: "circle-ripple",
      circle_image: "none",
      suc_msg: "",
      alert_msg: "",
      isAlertShown: false,
      loaded: false,
    };
  }

  addDefaultSrc(ev) {
    ev.target.src = require("../../assets/img/default_user.png");
  }

  handleItemClick(index) {
    this.setState({
      activeItems: index,
      selected_premium: index,
    });
    var premiumlist = new FormData();
    premiumlist.set("premiumid", index);
    premiumlist.set("language", this.state.langKey);
    premiumlist.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );

    axios({
      method: "post",
      url: this.state.api_url + "premiumid",
      data: premiumlist,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const data = res.data;
      this.setState({
        premium_price: data.result.original_price,
        permium_superlikeCount: data.result.superlikecount,
        permium_boostCount: data.result.boostcount,
      });
      localStorage.setItem("selected_premium", JSON.stringify(index));
      localStorage.setItem(
        "premium_price",
        JSON.stringify(data.result.original_price)
      );
      localStorage.setItem(
        "currency_premium_price",
        JSON.stringify(data.result.price)
      );
    });
  }

  closeModal(tabId) {
    if (tabId === "modal1") {
      var editprofile = new FormData();
      editprofile.set("swipe", "0");
      editprofile.set(
        "user_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );
      editprofile.set("language", this.state.langKey);
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("session_token")
      );

      axios({
        method: "post",
        url: this.state.api_url + "websetprofile",
        data: editprofile,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      });

      let data = new FormData();
      data.append(
        "user_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );
      data.append("language", this.state.langKey);
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("session_token")
      );

      axios({
        method: "post",
        url: this.state.api_url + "webprofile",
        data: data,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        if (res.data.status !== false) {
          const user_details = res.data.result;
          var face_verification_status =
            res.data.result.face_verification_status;
          localStorage.setItem(
            "session_faceverificationstatus",
            face_verification_status
          );
          this.setState({
            user_details: user_details,
          });
        }
      });

      this.setState({
        [tabId]: false,
      });
    } else {
      this.setState({
        [tabId]: false,
      });
    }
  }

  closeRealted() {
    this.setState({
      modal1: false,
    });

    var editprofile = new FormData();
    editprofile.set("swipe", "0");
    editprofile.set("language", this.state.langKey);
    editprofile.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );

    axios({
      method: "post",
      url: this.state.api_url + "websetprofile",
      data: editprofile,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    });

    let data = new FormData();
    data.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    data.append("language", this.state.langKey);
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );

    axios({
      method: "post",
      url: this.state.api_url + "webprofile",
      data: data,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      if (res.data.status !== false) {
        const user_details = res.data.result;

        this.setState({
          user_details: user_details,
        });
      }
    });

    var match = new FormData();
    match.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    match.append("language", this.state.langKey);

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );
    axios({
      method: "post",
      url: this.state.api_url + "webundomatch",
      data: match,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      var date = new Date();
      var details = new FormData();
      details.append(
        "user_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );
      details.append("timestamp", date.getTime());
      details.append("language", this.state.langKey);

      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("session_token")
      );
      axios({
        method: "post",
        url: this.state.api_url + "webgetpeople",
        data: details,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        const dataa = res.data;
        if (res.data.status === "true") {
          if (dataa.peoples.length === this.state.property.index) {
            this.setState({
              newindex: this.state.property.index - 1,
            });
          } else {
            this.setState({
              newindex: this.state.property.index,
            });
          }

          this.setState({
            liked: "",
            like_txt: "",
            superlike_txt: "",
            nope: "",
            nope_txt: "",
            peoples: dataa.peoples,
            property: dataa.peoples[this.state.newindex],
            imagess: dataa.peoples[this.state.newindex].imagess,
          });
        } else {
          this.setState({
            appholder1: "appHolder",
            appholder2: "none",
            change_loc: "amt20 apk-16 searchRipplePos",
            change_loc2: "sidebarLastContent searchRipplePos2",
          });
        }
      });
    });
  }

  showModal(modal) {
    if(modal=="modal6"){
      let superlike_viewproperties = {
        properties: {
          user_email: this.state.user_details.email,
          user_age: this.state.user_details.age,
          user_name: this.state.user_details.user_name,
          user_id: this.state.user_details.user_id,
          user_location: this.state.user_details.location,
        },
      };

      CAPTURE_EVENT("superlike_page_viewed", superlike_viewproperties);
    }
    this.setState({
      [modal]: true,
    });
  }

  homeLink() {
    this.setState({
      modal22: false,
    });
    this.props.history.push("/app");
  }

  closeModall(tabId) {
    this.setState({
      [tabId]: false,
    });

    if (tabId == "premmodal4") {
      localStorage.setItem("premium_popup", "");
    }
    if (tabId == "modal12" || tabId == "modal11" || tabId == "modal13") {
      this.props.history.push("/app");
    }
  }

  showModall(modal) {
    if(modal=="modal2"){
      let premium_view_properties = {
        properties: {
          user_email: this.state.user_details.email,
          user_age: this.state.user_details.age,
          user_name: this.state.user_details.user_name,
          user_id: this.state.user_details.user_id,
          user_location: this.state.user_details.location,
        },
      };

      CAPTURE_EVENT("premium_page_viewed", premium_view_properties);
    }
    if (this.state.user_details.premium_member === "true") {
      this.setState({
        modal3: true,
      });
    } else {
      this.setState({
        modal2: true,
      });
    }
  }

  getUserById(user_id) {
    let user = this.state.peoples.find((data) => {
      if (data.user_id == user_id) {
        return data;
      }
    });
    return user;
  }

  /*Message(frienduser_id) { 
        var report = new FormData();
        report.append('sender_id', JSON.parse(localStorage.getItem('session_userid')));
        report.append('receiver_id',frienduser_id); 
        report.append('language', 'en'); 
        axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));

        axios({
            method: 'post',
            url: this.state.api_url+'webcreatchat',
            data: report,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            const chatid = res.data.chatid;
            const friendid = frienduser_id; 
            // console.log("chatid",chatid);
            this.props.history.push(`/app/Message/MessageNew/${friendid}/${chatid}`) 
        })

    }*/

  handleLike(user_id, reqType) {
    //alert(reqType);
    if (
      this.state.user_details.premium_member === "false" &&
      reqType === "like" &&
      this.state.isAlertShown === false
    ) {
      console.log("yes non-premium");
      const message = "Premium users only access matches";

      this.setState({
        alert_msg: message,
        suc_msg: "successMsg floatingAlerts1",
      });

      setTimeout(() => {
        this.setState({
          suc_msg: "successMsghide",
          isAlertShown: true,
        });
      }, 5000);
    }
    var match = new FormData();
    match.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    match.append("follow_id", user_id);
    match.append("type", reqType);
    match.append("language", this.state.langKey);

    let receiver = this.getUserById(user_id);

    let properties = {
      sender_id: this.state.user_details.user_id,
      sender_email: this.state.user_details.email,
      sender_age: this.state.user_details.age,
      sender_name: this.state.user_details.user_name,
      sender_location: this.state.user_details.location,
      receiver_id: receiver.user_id,
      receiver_name: receiver.user_name,
      receiver_email: receiver.email,
      receiver_location: receiver.location,
    };

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );
    axios({
      method: "post",
      url: this.state.api_url + "webmatch",
      data: match,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const userDetails = res.data.likeresult;
      const userDetailss = res.data.result;
      const matchtotalcount = userDetails.unblock_to_match_count;
      // console.log('frienduser_id' + userDetailss.frienduser_id);

      //alert(userDetails);
      if (res.data.status === "true") {
        if (reqType == "like") {
          CAPTURE_EVENT("like_sent", {
            properties: properties,
          });
        } else {
          CAPTURE_EVENT("superlike_sent", {
            properties: properties,
          });

          userSend(this.state.user_details.user_id,"super_like").then(()=>{
            console.log("Superlike log noted")
          }).catch((err)=>{
            console.log(err)
          })
        }

        if (reqType == "like") {
          /*this.setState({
                                       totallikecount: this.state.totallikecount + 1  
                                   }); */
          var totallike = localStorage.getItem("totallikecount");
          localStorage.setItem("totallikecount", ++totallike);
          // alert(localStorage.getItem('totallikecount'));
        }

        this.setState({
          matches: "",
        });
        this.setState({
          liked: "likedS",
          nope: "",
          nope_txt: "",
        });

        if (reqType === "superlike") {
          this.setState({
            like_txt: "",
            superlike_txt: "Super like",
          });
        } else {
          this.setState({
            like_txt: "Like",
            superlike_txt: "",
          });
        }

        /*if(res.data.match === "1") {
                        this.setState({ 
                            matches: res.data.result   
                        });      
                        this.showModal('modal5');      
                    } */

        if (
          (reqType === "like" || reqType === "superlike") &&
          res.data.match == 1
        ) {
          let match_properties = {
            properties: {
              acceptor_id: this.state.user_details.user_id,
              acceptor_email: this.state.user_details.email,
              acceptor_age: this.state.user_details.age,
              acceptor_location: this.state.user_details.location,
              acceptor_name: this.state.user_details.user_name,
              requestor_id: receiver.user_id,
              requestor_email: receiver.email,
              requestor_name: receiver.user_name,
            },
          };

          CAPTURE_EVENT("match_created", match_properties);

          this.setState(
            {
              followername: userDetails.follow_firstname,
              followerprofile: userDetails.follow_profileimage,
              followerpremstatus: userDetails.follow_premiumstatus,
              userprofile: userDetails.profileimage,
              gif: "yes",
              profile_userid: userDetailss.frienduser_id,
            },
            () => {
              this.showModal("modal11");
              // setTimeout(() => this.closeModal('modal11'), 2000)
            }
          );
        } else if (
          reqType === "like" &&
          res.data.match == 0 &&
          userDetails.follow_premiumstatus == 1 &&
          userDetails.premiumstatus == 0
        ) {
          var afterlike = localStorage.getItem("totallikecount");

          //if(this.state.totallikecount == matchtotalcount){

          if (afterlike > matchtotalcount) {
            this.showModal("modal12");
            this.setState({
              followername: userDetails.follow_firstname,
              followerprofile: userDetails.follow_profileimage,
              followerpremstatus: userDetails.follow_premiumstatus,
              userprofile: userDetails.profileimage,
              premiumstatus: userDetails.premiumstatus,
              //totallikecount:0
              //gif:'yes'
            });

            //setTimeout(() => this.closeModal('modal12'), 2000)
            localStorage.setItem("totallikecount", 0);
          }
        } else if (
          reqType === "like" &&
          res.data.match == 0 &&
          userDetails.follow_premiumstatus == 0 &&
          userDetails.premiumstatus == 1
        ) {
          var afterlike = localStorage.getItem("totallikecount");

          if (afterlike > matchtotalcount) {
            this.showModal("modal13");
            this.setState({
              followername: userDetails.follow_firstname,
              followerprofile: userDetails.follow_profileimage,
              followerpremstatus: userDetails.follow_premiumstatus,
              userprofile: userDetails.profileimage,
              premiumstatus: userDetails.premiumstatus,
              //gif:'yes'
            });
            //setTimeout(() => this.closeModal('modal13'), 2000)
            localStorage.setItem("totallikecount", 0);
          }
        } else if (
          reqType === "superlike" &&
          res.data.match == 0 &&
          ((userDetails.follow_premiumstatus == 1 &&
            userDetails.premiumstatus == 0) ||
            (userDetails.follow_premiumstatus == 0 &&
              userDetails.premiumstatus == 1))
        ) {
          this.showModal("modal13");
          this.setState({
            followername: userDetails.follow_firstname,
            followerprofile: userDetails.follow_profileimage,
            followerpremstatus: userDetails.follow_premiumstatus,
            userprofile: userDetails.profileimage,
            premiumstatus: userDetails.premiumstatus,
            //gif:'yes'
          });
          setTimeout(() => this.closeModal("modal13"), 2000);
        } else if (
          reqType === "like" &&
          res.data.match == 0 &&
          userDetails.follow_premiumstatus == 0 &&
          userDetails.premiumstatus == 0
        ) {
          //if(this.state.totallikecount == matchtotalcount){

          var afterlike = localStorage.getItem("totallikecount");

          if (afterlike > matchtotalcount) {
            this.showModal("modal12");
            this.setState({
              followername: userDetails.follow_firstname,
              followerprofile: userDetails.follow_profileimage,
              followerpremstatus: userDetails.follow_premiumstatus,
              userprofile: userDetails.profileimage,
              premiumstatus: userDetails.premiumstatus,
              //totallikecount:0
              //gif:'yes'
            });

            //setTimeout(() => this.closeModal('modal12'), 2000)
            localStorage.setItem("totallikecount", 0);
          }
        } else if (
          reqType === "superlike" &&
          res.data.match == 0 &&
          userDetails.follow_premiumstatus == 0 &&
          userDetails.premiumstatus == 0
        ) {
          this.showModal("modal13");
          this.setState({
            followername: userDetails.follow_firstname,
            followerprofile: userDetails.follow_profileimage,
            followerpremstatus: userDetails.follow_premiumstatus,
            userprofile: userDetails.profileimage,
            premiumstatus: userDetails.premiumstatus,
            //gif:'yes'
          });

          setTimeout(() => this.closeModal("modal13"), 2000);
        } else if (
          (reqType === "like" || reqType === "superlike") &&
          res.data.match == 0 &&
          userDetails.follow_premiumstatus == 1 &&
          userDetails.premiumstatus == 1
        ) {
          var afterlike = localStorage.getItem("totallikecount");

          if (afterlike > matchtotalcount && reqType === "like") {
            this.showModal("modal13");
            this.setState({
              followername: userDetails.follow_firstname,
              followerprofile: userDetails.follow_profileimage,
              followerpremstatus: userDetails.follow_premiumstatus,
              userprofile: userDetails.profileimage,
              //gif:'yes'
            });
            setTimeout(() => this.closeModal("modal13"), 2000);

            localStorage.setItem("totallikecount", 0);
          } else {
            this.showModal("modal13");
            this.setState({
              followername: userDetails.follow_firstname,
              followerprofile: userDetails.follow_profileimage,
              followerpremstatus: userDetails.follow_premiumstatus,
              userprofile: userDetails.profileimage,
              //gif:'yes'
            });
            setTimeout(() => this.closeModal("modal13"), 2000);
          }
        } else {
          this.props.history.push("/app");
        }

        var date = new Date();
        var details = new FormData();
        details.append(
          "user_id",
          JSON.parse(localStorage.getItem("session_userid"))
        );
        details.append("timestamp", date.getTime());
        details.append("limit", 20);
        details.append("language", this.state.langKey);

        axios.defaults.headers.common["Authorization"] = JSON.parse(
          localStorage.getItem("session_token")
        );
        axios({
          method: "post",
          url: this.state.api_url + "webgetpeople",
          data: details,
          config: { headers: { "Content-Type": "multipart/form-data" } },
        }).then((res) => {
          // console.log(res.data);
          const dataa = res.data;
          if (res.data.status === "true") {
            this.setState({
              undostatus: "true",
              undo: "1",
            });
            if (dataa.peoples.length === this.state.property.index) {
              this.setState({
                newindex: this.state.property.index - 1,
              });
            } else {
              this.setState({
                newindex: this.state.property.index,
              });
            }
            this.setState({
              liked: "",
              like_txt: "",
              superlike_txt: "",
              nope: "",
              nope_txt: "",
              peoples: dataa.peoples,
              property: dataa.peoples[this.state.newindex],
              imagess: dataa.peoples[this.state.newindex].imagess,
            });

            this.setState({
              loaded: false,
            });

            const img = new Image();
            img.src = this.state.imagess;
            img.onload = () => {
              this.setState({
                loaded: true,
              });
            };
          } else {
            this.setState({
              appholder1: "appHolder",
              appholder2: "none",
              change_loc: "amt20 apk-16 searchRipplePos",
              change_loc2: "sidebarLastContent searchRipplePos2",
            });
          }
        });
      } else {
        if (reqType == "like") {
          CAPTURE_EVENT("like_sent", {
            properties: properties,
          });
        } else {
          CAPTURE_EVENT("superlike_sent", {
            properties: properties,
          });
        }

        this.setState({
          liked: "",
          like_txt: "",
          superlike_txt: "",
          nope: "",
          nope_txt: "",
        });

        if (reqType === "superlike" && res.data.superlike_count === "0") {
          var premiumlist = new FormData();
          premiumlist.append(
            "user_id",
            JSON.parse(localStorage.getItem("session_userid"))
          );
          premiumlist.append("platform", "web");
          premiumlist.append("language", this.state.langKey);
          axios.defaults.headers.common["Authorization"] = JSON.parse(
            localStorage.getItem("session_token")
          );

          axios({
            method: "post",
            url: this.state.api_url + "websuperlikelist",
            data: premiumlist,
            config: { headers: { "Content-Type": "multipart/form-data" } },
          }).then((res) => {
            if (res.data.status === "true") {
              const data = res.data;

              
              this.setState({
                superlikeItems: data.result,
                activeItem: data.result[0].id,
                selected_superlikepremium: data.result[0].id,
                superlikepremium_price: data.result[0].original_price,
                currency: data.currency,
                payment: data.payment,
                license_key: data.license_key,
                superlikePlanStatus: 1,
                superlikeCount: data.superlike_count,
              });
              localStorage.setItem(
                "selected_superlikepremium",
                JSON.stringify(this.state.selected_superlikepremium)
              );
              localStorage.setItem(
                "superlikepremium_price",
                JSON.stringify(this.state.superlikepremium_price)
              );
              localStorage.setItem(
                "currency_superlikepremium_price",
                JSON.stringify(data.result[0].price)
              );
              localStorage.setItem(
                "currency",
                JSON.stringify(this.state.currency)
              );

              this.showModal("modal6");
            }
          });
        } else if (reqType === "like" && userDetails.like_count === 0) {
          this.setState(
            {
              start_date: userDetails.start_date,
              end_date: userDetails.end_date,
            },
            () => {
              this.showModal("modal10");
            }
          );
        }

        // console.log('People Near you webmatch Error' + res.data.message);
      }
    });
  }

  message = () => {
    //  alert('yes'+ this.state && this.state.profile_userid);

    var report = new FormData();
    report.append(
      "sender_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    report.append("receiver_id", this.state.profile_userid);
    report.append("language", this.state.langKey);
    axios({
      method: "post",
      url: this.state.api_url + "webcreatchat",
      data: report,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const chatid = res.data.chatid;
      // console.log("chatid",chatid);
      this.props.history.push(
        `/app/Message/MessageNew/${this.state.profile_userid}/${chatid}`
      );
    });
  };

  handleSuperlikeItemClick(index) {
    this.setState({
      activeItem: index,
      selected_superlikepremium: index,
    });

    var premiumsuperlikelist = new FormData();
    premiumsuperlikelist.set("premiumsuperlikeid", index);
    premiumsuperlikelist.set("language", this.state.langKey);
    premiumsuperlikelist.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );

    axios({
      method: "post",
      url: this.state.api_url + "premiumsuperlikeid",
      data: premiumsuperlikelist,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const data = res.data;
      this.setState({
        superlikepremium_price: data.result.original_price,
      });
      localStorage.setItem("selected_superlikepremium", JSON.stringify(index));
      localStorage.setItem(
        "superlikepremium_price",
        JSON.stringify(data.result.original_price)
      );
      localStorage.setItem(
        "currency_superlikepremium_price",
        JSON.stringify(data.result.price)
      );
    });
  }

  componentDidMount() {
    //order id
    const search = window.location.search;
    const params = new URLSearchParams(search);
    let payment_session_id = params.get("orderId");
    if (payment_session_id) {
      let data = new FormData();
      data.append(
        "user_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );
      data.append("language", this.state.langKey);
      data.append("order_id", payment_session_id);

      axios({
        method: "post",
        url: this.state.api_url + "cibresponse",
        data: data,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        console.log(res);
        if (res.data.status === "false") {
          // this.setState({
          //     alert_msg: res.data.message,
          //     suc_msg: 'successMsg floatingAlerts1',
          // });
          this.setState({
            modal22: true,
            backdrop: false,
            message: res.data.message,
          });

          // setTimeout(() => {
          //     this.setState({
          //         suc_msg: 'successMsghide',
          //         isAlertShown: true
          //     });
          // }, 5000);
        }
      });
    }
    if (localStorage.getItem("premium_popup") === "1") {
      this.setState({
        premmodal4: true,
      });
    }

    if (localStorage.getItem("like_updated") === "1") {
      const message = (
        <Trans i18nKey="Your free Like is added , kindly use it">
          Your free likes are ready to use
        </Trans>
      );

      this.setState({
        alert_msg: message,
        suc_msg: "successMsg floatingAlerts1",
      });

      setTimeout(() => {
        localStorage.setItem("like_updated", "0");
        this.setState({
          suc_msg: "successMsghide",
          isAlertShown: true,
        });
      }, 5000);
    }

    localStorage.setItem("filter_page", "1");
    if (localStorage.getItem("referred_signup_msg_showed") !== null) {
      var referred_msg_showed_flag = localStorage.getItem(
        "referred_signup_msg_showed"
      );
      if (referred_msg_showed_flag === "0") {
        var referred_login_msg = localStorage.getItem("referred_signup_msg");
        this.setState(
          {
            referred_login_message: referred_login_msg,
            referred_login_msg_modal: true,
          },
          () => {
            localStorage.setItem("referred_signup_msg_showed", "1");
          }
        );
      }
    }
    this.setState({
      appholder1: "appHolder",
      appholder2: "none",
    });

    this.setState({
      tmp_image: "none",
      circle_image: "circle-ripple",
    });
    let free_premium = JSON.parse(localStorage.getItem("free_premium_enabled"));
    let premium_days = JSON.parse(localStorage.getItem("free_premium_days"));
    console.log("free_premium" + free_premium + "==" + premium_days);
    if (
      free_premium ||
      parseInt(premium_days) > 0 ||
      (free_premium == "true" && parseInt(premium_days) > 0)
    ) {
      console.log("yes free premium exists");
      this.setState({
        free_premium_enabled: true,
        free_premium_days: premium_days,
      });
      console.log(
        "free_premium_enabledd" +
          this.state.free_premium_enabled +
          "==" +
          this.state.free_premium_days
      );
      localStorage.setItem("free_premium_enabled", false);
      localStorage.setItem("free_premium_days", 0);
    } else {
      console.log("not yet working" + free_premium + "==" + premium_days);
    }
    let data = new FormData();
    data.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    data.append("language", this.state.langKey);
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );

    axios({
      method: "post",
      url: this.state.api_url + "webprofile",
      data: data,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      if (res.data.status !== false) {
        const user_details = res.data.result;
        if (user_details.profileimage == "") {
          this.props.history.push("/app/Profile/ProfilePhotoEdit");
        }

        this.setState({
          user_details: user_details,
        });
      }
    });

    var date = new Date();
    var details = new FormData();
    details.append(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    details.append("timestamp", date.getTime());
    details.append("language", this.state.langKey);

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );
    axios({
      method: "post",
      url: this.state.api_url + "webgetpeople",
      data: details,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      if (res.data.status === "false") {
        this.setState({
          appholder1: "appHolder",
          appholder2: "none",
          change_loc: "amt20 apk-16 searchRipplePos",
          change_loc2: "sidebarLastContent searchRipplePos2",
        });
      } else {
        const dataa = res.data;
        this.setState({
          peoples: dataa.peoples,
          property: dataa.peoples[0],
          imagess: dataa.peoples[0].imagess,
        });

        const img = new Image();
        img.src = this.state.imagess;
        img.onload = () => {
          this.setState({
            loaded: true,
          });
        };

        setTimeout(() => {
          this.setState({
            appholder1: "none",
            appholder2: "appHolder",
          });
        }, 2000);
      }
    });

    var premiumlist = new FormData();
    premiumlist.set("platform", "web");
    premiumlist.set("language", this.state.langKey);
    premiumlist.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );

    axios({
      method: "post",
      url: this.state.api_url + "premiumlistweb",
      data: premiumlist,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const data = res.data;
      if (data.result[0]) {
      
        this.setState({
          itemss: data.result,
          activeItems: data.result[0].id,
          selected_premium: data.result[0].id,
          premium_price: data.result[0].original_price,
          permium_superlikeCount: data.result[0].superlikecount,
          permium_boostCount: data.result[0].boostcount,
          currency: data.currency,
          payment: data.payment,
          license_key: data.license_key,
          start_date: data.start_date,
          end_date: data.end_date,
          timer_status: data.timer_status,
        });
      }
      localStorage.setItem(
        "selected_premium",
        JSON.stringify(this.state.selected_premium)
      );
      localStorage.setItem(
        "premium_price",
        JSON.stringify(this.state.premium_price)
      );
      localStorage.setItem(
        "currency_premium_price",
        JSON.stringify(data.result[0].price)
      );
      localStorage.setItem("currency", JSON.stringify(this.state.currency));
    });
  }

  next_Property(user_id) {
    //alert(user_id);
    if (this.state.user_details.swipe === "1") {
      this.setState({
        modal1: true,
      });
    }
    this.setState({
      liked: "",
      like_txt: "",
      superlike_txt: "",
      nope: "disLikedNope",
      nope_txt: "Nope",
      hide: "hideMe",
    });
    setTimeout(() => {
      this.setState({
        nope: "",
        nope_txt: "",
      });
    }, 100);
    var match = new FormData();
    match.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    match.append("follow_id", user_id);
    match.append("language", this.state.langKey);

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );
    axios({
      method: "post",
      url: this.state.api_url + "webunmatch",
      data: match,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      // console.log(res.data.status);
      var date = new Date();
      var details = new FormData();
      details.append(
        "user_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );
      details.append("timestamp", date.getTime());
      details.append("language", this.state.langKey);

      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("session_token")
      );
      axios({
        method: "post",
        url: this.state.api_url + "webgetpeople",
        data: details,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        // console.log(res.data);
        const dataa = res.data;
        if (res.data.status === "true") {
          this.setState({
            undostatus: "true",
            undo: "1",
          });
          if (dataa.peoples.length === this.state.property.index) {
            this.setState({
              newindex: this.state.property.index - 1,
              undostatus: "true",
              undo: "1",
            });
          } else {
            this.setState({
              newindex: this.state.property.index,
            });
          }

          this.setState({
            liked: "",
            like_txt: "",
            superlike_txt: "",
            nope: "",
            nope_txt: "",
            peoples: dataa.peoples,
            property: dataa.peoples[this.state.newindex],
            imagess: dataa.peoples[this.state.newindex].imagess,
          });

          this.setState({
            loaded: false,
          });

          const img = new Image();
          img.src = this.state.imagess;
          img.onload = () => {
            this.setState({
              loaded: true,
            });
          };
          // console.log("IMAGESS " +dataa.peoples[this.state.newindex].imagess);
        } else {
          this.setState({
            appholder1: "appHolder",
            appholder2: "none",
            change_loc: "amt20 apk-16 searchRipplePos",
            change_loc2: "sidebarLastContent searchRipplePos2",
          });
        }
      });
    });
  }
  nextProperty = (user_id) => {};
  prevProperty = () => {
    if (this.state.user_details.premium_member !== "true") {
      this.setState({
        modal2: "true",
      });

      this.setState({
        start_date: "",
        end_date: "",
        timer_status: 0,
      });

      var premiumlist = new FormData();
      premiumlist.set("platform", "web");
      premiumlist.set("language", this.state.langKey);
      premiumlist.set(
        "user_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );

      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("session_token")
      );

      axios({
        method: "post",
        url: this.state.api_url + "premiumlistweb",
        data: premiumlist,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        const data = res.data;
        if (data.result[0]) {
         
          this.setState({
            itemss: data.result,
            activeItems: data.result[0].id,
            selected_premium: data.result[0].id,
            premium_price: data.result[0].original_price,
            permium_superlikeCount: data.result[0].superlikecount,
            permium_boostCount: data.result[0].boostcount,
            currency: data.currency,
            payment: data.payment,
            license_key: data.license_key,
            start_date: data.start_date,
            end_date: data.end_date,
            timer_status: data.timer_status,
          });
        }
        localStorage.setItem(
          "selected_premium",
          JSON.stringify(this.state.selected_premium)
        );
        localStorage.setItem(
          "premium_price",
          JSON.stringify(this.state.premium_price)
        );
        localStorage.setItem(
          "currency_premium_price",
          JSON.stringify(data.result[0].price)
        );
        localStorage.setItem("currency", JSON.stringify(this.state.currency));
      });
    } else {
      if (this.state.undo === "1" && this.state.undostatus === "true") {
        var match = new FormData();
        match.append(
          "user_id",
          JSON.parse(localStorage.getItem("session_userid"))
        );
        match.append("language", this.state.langKey);

        axios.defaults.headers.common["Authorization"] = JSON.parse(
          localStorage.getItem("session_token")
        );
        axios({
          method: "post",
          url: this.state.api_url + "webundomatch",
          data: match,
          config: { headers: { "Content-Type": "multipart/form-data" } },
        }).then((res) => {
          // console.log(res.data.status);
          if (res.data.status !== false) {
            var date = new Date();
            var details = new FormData();
            details.append(
              "user_id",
              JSON.parse(localStorage.getItem("session_userid"))
            );
            details.append("timestamp", date.getTime());
            details.append("language", this.state.langKey);

            axios.defaults.headers.common["Authorization"] = JSON.parse(
              localStorage.getItem("session_token")
            );
            axios({
              method: "post",
              url: this.state.api_url + "webgetpeople",
              data: details,
              config: { headers: { "Content-Type": "multipart/form-data" } },
            }).then((res) => {
              //console.log(res.data);
              const dataa = res.data;
              if (res.data.status === "true") {
                this.setState({
                  undostatus: "false",
                  undo: "0",
                });
                if (dataa.peoples.length === this.state.property.index) {
                  this.setState({
                    newindex: this.state.property.index - 1,
                  });
                } else {
                  this.setState({
                    newindex: this.state.property.index,
                  });
                }
                this.setState({
                  liked: "",
                  like_txt: "",
                  superlike_txt: "",
                  nope: "",
                  nope_txt: "",
                  peoples: dataa.peoples,
                  property: dataa.peoples[this.state.newindex],
                  imagess: dataa.peoples[this.state.newindex].imagess,
                });

                this.setState({
                  loaded: false,
                });

                const img = new Image();
                img.src = this.state.imagess;
                img.onload = () => {
                  this.setState({
                    loaded: true,
                  });
                };
              } else {
                this.setState({
                  appholder1: "appHolder",
                  appholder2: "none",
                  change_loc: "amt20 apk-16 searchRipplePos",
                  change_loc2: "sidebarLastContent searchRipplePos2",
                });
              }
            });
          }
        });
      }
    }
  };

  // prevProperty = () => {
  //     const newIndex = this.state.property.index - 1;
  //     this.setState({
  //         property: this.state.peoples[newIndex]
  //     })
  // }
  onSubmitlocationsearch(e) {
    e.preventDefault();
    let errors = {};
    // alert(this.state.place);
    // if(this.state.lat === "" ||this.state.lat === null ||  this.state.lon === "" || this.state.place=== "" || this.state.place=== null){
    //alert("tyu")
    if (
      typeof this.state.lat === "undefined" ||
      typeof this.state.lon === "undefined" ||
      this.state.lat === "undefined" ||
      this.state.lat === "" ||
      this.state.lat === null ||
      this.state.lon === "" ||
      this.state.lon === "undefined" ||
      this.state.place === "" ||
      this.state.place === null ||
      this.state.place === "undefined"
    ) {
      this.setState({
        locationerr: "please select the location",
      });
    } else if (
      typeof this.state.lat === "undefined" ||
      typeof this.state.lon === "undefined"
    ) {
      this.setState({
        locationerr: "please select the location from dropdown",
      });
      // console.log(this.state.lat);
      // console.log(this.state.lon);
    } else {
      var location = new FormData();
      if (this.state.place) {
        var address = this.state.place;
        var value = address.split(",");
        var count = value.length;
        var country = value[count - 1];
        var state = value[count - 2];
        var city = value[count - 3];
        //  console.log(city+" "+state+" "+country);
        // location.append('place', city+", "+state+", "+country);
        // this.setState({
        //     loc: city+", "+state+", "+country
        // });
        if (city != null) {
          //alert(city)
          location.append("place", city + ", " + state + ", " + country);
          this.setState({
            loc: city + ", " + state + ", " + country,
          });
        } else {
          location.append("place", state + ", " + country);
          this.setState({
            loc: +state + ", " + country,
          });
        }
      }
      location.append("lat", this.state.lat);
      location.append("lon", this.state.lon);
      location.append("language", this.state.langKey);
      location.append(
        "user_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );

      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("session_token")
      );

      axios({
        method: "post",
        url: this.state.api_url + "websetprofile",
        data: location,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        const status = res.data.status;
        //   console.log(res.data);
        if (status === "true") {
          // this.setState({ showNav3: true })

          this.setState({
            modal3: false,
          });
          //this.props.history.push("/app/PeopleNear")
          window.location.reload();
        } else {
        }
      });
    }
    this.setState({
      errors: errors,
    });
  }

  render() {
    const { t } = this.props;

    const { property } = this.state;
    const { loaded } = this.state;

    // const { index, images, user_name, location, age,user_id,show_location } = property;

    const {
      index,
      user_name,
      location,
      age,
      user_id,
      show_location,
      face_verified,
    } = property;

    // var imagess = ["http://localhost/Howzu/4.0/uploads/user/1588246122.jpeg", "http://localhost/Howzu/4.0/uploads/user/1554466222.jpeg"];

    const settings = {
      dots: false,
      arrows: false,
      infinite: false,
      speed: 500,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    const params = {
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      spaceBetween: 1,
      rebuildOnUpdate: true,
    };

    const params2 = {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      slidesPerView: 3,
      slidesPerColumn: 1,
      breakpoints: {
        360: {
          slidesPerView: 3,
        },
        359: {
          slidesPerView: 2,
        },
      },
    };

    return (
      <div className="setting-page peopleNpage">
        <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg amb10 ">
          <div class="heading-left-top d-flex">
            <div className="align-self-center d-block d-lg-none">
              <div className="iconHolder align-self-center mr-1">
                <div className="backGlow">
                  <div
                    className="sideBarToggler sidebarIcoPos"
                    onClick={() => this.setState({ showNav3: true })}
                  ></div>
                </div>
              </div>
            </div>
            <span class="arrow-center align-self-center d-none ml-2 bold-font">
              <Trans i18nKey="People near you">People near you</Trans>
            </span>
            <Boost />
          </div>

          <div className="align-self-center  d-block">
            <span class="heading-left-top arrow-center align-self-center ml-2 bold-font">
              <Trans i18nKey="Around you">Around you</Trans>
            </span>
            <img
              src={require("../../assets/img/logo-c-64.png")}
              className="d-none sideLogo commonLogoC"
              alt="logo"
            />
          </div>

          <div className="iconHolder align-self-center">
            <NavLink to={`/app/Filter`}>
              <div className="backGlow">
                <div className="sidebarIcoPos filterIcon align-self-center"></div>
              </div>
            </NavLink>
          </div>
        </div>
        <div className={this.state.appholder1}>
          <div className="d-flex flex-column align-items-center relPos">
            <div class={this.state.circle_image}>
              <img
                src={this.state.user_details.images}
                alt=""
                class="profilePageDp"
              />
            </div>
            <div class={this.state.tmp_image}>
              <img src={this.addDefaultSrc} alt="" class="profilePageDp" />
            </div>
            <div className={this.state.change_loc}>
              <Trans i18nKey="No people in your location">
                No people in your location
              </Trans>
            </div>
            <div class={this.state.change_loc2}>
              <button
                class="btn-common w200px"
                onClick={this.showModall.bind(this, "modal2")}
              >
                <Trans i18nKey="Change Location">Change Location</Trans>
              </button>
              <div></div>
            </div>
          </div>
        </div>

        <div className={this.state.appholder2}>
          <div className="ProfileSpace peopleSlides apd5">
            <div className="peopleINSpaceHolder  peopleSlides">
              <div className="peopleINViewHolder initialCursor">
                <div className="peopleINPic relPos ">
                  <button
                    title={t("Rewind")}
                    onClick={() => this.prevProperty()}
                    value={property.index}
                    className="swiper-button-prev border-0"
                  ></button>
                  <button
                    title={t("Dislike")}
                    onClick={() => this.next_Property(user_id)}
                    value={user_id}
                    alt={user_id}
                    disabled={
                      property.index === 0
                        ? ""
                        : property.index === this.state.peoples.length - 1
                    }
                    className="swiper-button-next border-0"
                  ></button>
                  <div className="page">
                    <div id={`card-${index}`}>
                      {/*<NavLink to={`/app/PeopleNear/PeopleExplore/${user_id}`}>
                                        <img src={images} alt='' />  
                                    </NavLink>*/}

                      <Slider {...settings}>
                        {this.state.imagess.map((image_tmp) => (
                          <div>
                            <NavLink
                              to={`/app/PeopleNear/PeopleExplore/${user_id}`}
                            >
                              {/*<img src={image_tmp} id="current_image" alt="" value={image_tmp} className="" />*/}
                              {this.state.loaded ? (
                                <img
                                  src={image_tmp}
                                  id="current_image"
                                  alt=""
                                  value={image_tmp}
                                  className=""
                                />
                              ) : (
                                <img
                                  src="https://moulook.com/moulookweb/public/solid_gray.jpg"
                                  id="current_image"
                                  alt=""
                                  value="https://moulook.com/moulookweb/public/solid_gray.jpg"
                                  className=""
                                />
                              )}
                            </NavLink>
                          </div>
                        ))}
                      </Slider>

                      {/* 
                                        <span className="index">{index+1}</span>
                                        */}
                      <NavLink to={`/app/PeopleNear/PeopleExplore/${user_id}`}>
                        <div className="peopleSlideDetails">
                          <div className="media text-center">
                            <div className="media-body pFHidden align-self-center">
                              <div
                                className="d-flex align-items-center"
                                style={{ justifyContent: "center" }}
                              >
                                <div className="bold-font  apk-18 text-light apl10 apr10">
                                  {user_name}, {age}
                                </div>
                                {face_verified && face_verified === "true" && (
                                  <div class="verificationIcon"></div>
                                )}
                              </div>
                              <div className="col-6 offset-3 secondaryText rtlcls apk-16 regular-font text-light apl10 apr10">
                                {show_location === true ? "" : location}
                              </div>
                            </div>
                          </div>
                        </div>
                      </NavLink>
                      {this.state.like_txt !== "" ? (
                        <div className={this.state.liked}>
                          {" "}
                          <Trans i18nKey={this.state.like_txt}>
                            {this.state.like_txt}
                          </Trans>{" "}
                        </div>
                      ) : (
                        <div className={this.state.liked}>
                          {" "}
                          <Trans i18nKey={this.state.superlike_txt}>
                            {this.state.superlike_txt}
                          </Trans>{" "}
                        </div>
                      )}
                      <div>
                        <div className={this.state.nope}>
                          {" "}
                          <Trans i18nKey={this.state.nope_txt}>
                            {this.state.nope_txt}
                          </Trans>{" "}
                        </div>
                      </div>

                      {this.state.like_txt && (
                        <div
                          className="likeButton"
                          title={t("Like")}
                          value={user_id}
                          alt={user_id}
                        ></div>
                      )}
                      {!this.state.like_txt && (
                        <div
                          className="likeButton"
                          title={t("Like")}
                          value={user_id}
                          alt={user_id}
                          onClick={() => {
                            this.handleLike(user_id, this.state.like);
                          }}
                        ></div>
                      )}

                      {this.state.superlike_txt && (
                        <div
                          className="superlikeButton"
                          title={t("Super like")}
                          value={user_id}
                          alt={user_id}
                        ></div>
                      )}
                      {!this.state.superlike_txt && (
                        <div
                          className="superlikeButton"
                          title={t("Super like")}
                          value={user_id}
                          alt={user_id}
                          onClick={() => {
                            this.handleLike(user_id, this.state.superlike);
                          }}
                        ></div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sidebarResp d-block d-lg-none">
          <SideNav
            showNav={this.state.showNav3}
            onHideNav={() => this.setState({ showNav3: false })}
            title={<div></div>}
            items={[<SideBar />]}
          />
        </div>
        <Modal
          isOpen={this.state.modal1}
          toggle={this.closeRealted.bind(this, "modal1")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeRealted.bind(this, "modal1")}>
            <h4 class="modal-title">
              <Trans i18nKey="Remove related matches ?">
                Remove related matches ?
              </Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={this.closeModal.bind(this, "modal1")}
                  >
                    <Trans i18nKey="Yes">Yes</Trans>
                  </button>
                </div>
                <div>
                  <button
                    class="border-0 bg-white"
                    onClick={this.closeRealted.bind(this, "modal1")}
                  >
                    <Trans i18nKey="No">No</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        {/* Premium Popup  */}
        <Modal
          isOpen={this.state.modal2}
          toggle={this.closeModal.bind(this, "modal2")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal2")}>
            <h4 class="modal-title">
              <Trans i18nKey="Join Premium">Join Premium</Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="premiumPop">
              <div className="premiumImgs">
                <Swiper {...params} shouldSwiperUpdate>
                  {this.state.permium_superlikeCount > 0 ? (
                    <div>
                      <div className="premiumImgHolder">
                        <img
                          src={require("../../assets/img/sub_superlike.png")}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <div className="premiumInfoHolder">
                        <div className="bold-font">
                          <Trans i18nKey="Get">Get</Trans>{" "}
                          {this.state.permium_superlikeCount}{" "}
                          <Trans i18nKey="free super likes">
                            free super likes
                          </Trans>
                        </div>
                        <div className="premiumInfoSubText  secondaryText esmh-14 ">
                          <Trans i18nKey="premiumTextSuper">
                            Giving a Super like is a way to tell someone that
                            you're especially interested in them
                          </Trans>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.state.permium_boostCount > 0 ? (
                    <div>
                      <div className="premiumImgHolder">
                        <img
                          src={require("../../assets/img/sub_boost.png")}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <div className="premiumInfoHolder">
                        <div className="bold-font">
                          {this.state.permium_boostCount}{" "}
                          <Trans i18nKey="free boost">free boost</Trans>
                        </div>
                        <div className="premiumInfoSubText  secondaryText esmh-14 ">
                          <Trans i18nKey="premiumTextBoost">
                            Be the top profile in your area for 30minutes to get
                            more matches, Keep Swipe right!
                          </Trans>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_location.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Change Location">Change Location</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextLocation">
                          Get match and chat with others around the world by
                          simply searching for a city
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_morelike.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Unlimited Likes">Unlimited Likes</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextUnlimited">
                          Feel special again with 'Unlimited Likes'. Swipe right
                          as much as you want!
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sud_add.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Rewind">Rewind</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextRewind">
                          Accidentally swiped on someone? Rewind lets you take
                          back your last Like or Nope
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_morelike2.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Unlimited Liked">
                          Find out who likes you
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextUnlimiteds">
                          This feature allows you to see who has liked you!
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_profile.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Control your profile">
                          Control your profile
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextProfile">
                          Limit what others see and make parts of your profile
                          information invisible to other people
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_visited.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Visitors">
                          See who visited your profile
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextVisited">
                          A Visitors feature lets you see who looked at your
                          profile or ‘visited’ your profile
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sud_add2.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Turn Off Ads">Turn Off Ads</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextAds">
                          Have fun swiping with uninterrupted ads
                        </Trans>
                      </div>
                    </div>
                  </div>
                </Swiper>
              </div>

              {this.state.timer_status == 1 ? (
                <Countdown
                  startdate={this.state.start_date}
                  enddate={this.state.end_date}
                ></Countdown>
              ) : (
                ""
              )}

              <div className="premiumPopPlans">
                <Swiper {...params2}>
                  {this.state.itemss.map((item, index) => (
                    <div
                      className={
                        this.state.activeItems === item.id
                          ? "navigation--active"
                          : ""
                      }
                      onClick={this.handleItemClick.bind(this, item.id)}
                      alt={item.id}
                      value={item.id}
                    >
                      <div className="premiumPrice">
                        <div className="apd10 daysPrice">
                          <div className="bold-font apk-30">{item.days}</div>
                          <div className=" bold-font apk-24 mt-n2">
                            <Trans i18nKey={item.type}>{item.type}</Trans>
                          </div>
                        </div>
                        <div className="apd5 apk-16 mini-price">
                          {this.state.currency}
                          {item.price}
                        </div>
                      </div>
                    </div>
                  ))}
                </Swiper>
              </div>

              {/* <div className="sidebarLastContent text-center">
                            <NavLink to={{
                                pathname:'/app/WalletPayment',
                                paytype: {type:'premium'} 
                            }}>  <button className="btn-common btn-block"><Trans i18nKey="Continue">Continue</Trans></button></NavLink>
                            </div> */}

              <ul class="ubp-ul text-center justify-content-end amt20">
                <li class="in-flex">
                  <button
                    class="btn-block amgAuto border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal2")}
                  >
                    <Trans i18nKey="Cancel">Cancel</Trans>
                  </button>
                </li>
                <li class="in-flex">
                  <NavLink
                    to={{
                      pathname: "/app/WalletPayment",
                      paytype: { type: "premium" },
                    }}
                  >
                    {" "}
                    <button class="btn-block amgAuto border-0 bg-white pink-color">
                      <Trans i18nKey="Continue">Continue</Trans>{" "}
                    </button>
                  </NavLink>
                </li>
              </ul>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal3}
          toggle={this.closeModal.bind(this, "modal3")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal3")}>
            <h4 class="modal-title">
              <Trans i18nKey="Change Location">Change Location</Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body edit-profile-page">
              <form className="" onSubmit={this.onSubmitlocationsearch}>
                <div className="user-input-wrp amb35">
                  <br />
                  {/*  <GoogleComponent
                                        apiKey={API_KEY}
                                        language={'en'}
                                        //country={'country:in|country:us'}
                                        coordinates={true}
                                        locationBoxStyle={'inputText'}
                                        locationListStyle={'custom-style-list'}
                                        onChange={(e) => { this.setState({ place: e.place, lat: e.coordinates.lat , lon: e.coordinates.lng }) }} 
                                        />*/}
                  <Autocomplete
                    apiKey={API_KEY}
                    onPlaceSelected={(place) => {
                      this.setState({
                        place: place.formatted_address,
                        lat: place.geometry.location.lat(),
                        lon: place.geometry.location.lng(),
                      });
                    }}
                    types={["(regions)"]}
                    //componentRestrictions={{country: "ru"}}
                  />
                </div>
                {/* <div className="errorMsg">{this.state.errors.locationsearch}</div> */}
                <div className="errorMsg">
                  <Trans i18nKey={this.state.locationerr}>
                    {this.state.locationerr}
                  </Trans>
                </div>
                <div className="premium">
                  <button
                    type="Submit"
                    className="btn btn-bg width100 justify-content-center amg0"
                  >
                    {" "}
                    <Trans i18nKey="Joinwith">Join with Moulook</Trans>{" "}
                  </button>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal5}
          toggle={this.closeModall.bind(this, "modal5")}
          className="premiumPopup matchPopup vertically-center apd5"
        >
          <ModalHeader
            toggle={this.closeModall.bind(this, "modal5")}
          ></ModalHeader>
          <ModalBody>
            <div class="modal-images media">
              <div class="matchmedia">
                <img
                  src={this.state.matches.loguser_image}
                  alt=""
                  className=""
                />
              </div>
              <div class="matchlike"></div>
              <div class="matchmedia">
                <img
                  src={this.state.matches.frienduser_image}
                  alt=""
                  className=""
                />
              </div>
            </div>

            <div class="justify-content-end text-center matchContent">
              <Trans i18nKey="It's a Match!">It's a Match!</Trans>
            </div>
            <div class="justify-content-end text-center matchContentSub">
              <Trans i18nKey="Bel Baraka">Bel Baraka</Trans>
            </div>
            <div class="justify-content-end text-center"></div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal6}
          toggle={this.closeModall.bind(this, "modal6")}
          className="premiumPopup superlikePopup vertically-center apd5"
        >
          <ModalHeader
            toggle={this.closeModall.bind(this, "modal6")}
          ></ModalHeader>
          <ModalBody>
            <div className="boostPopupIcon"></div>
            <div className="premiumPop">
              {this.state.superlikePlanStatus === 1 ? (
                <div className="premiumPopPlans pt-3">
                  <div className="text-center mb-3">
                    <div class="bold-font">
                      <Trans i18nKey="Out of Super Likes">
                        Out of Super Likes
                      </Trans>
                    </div>
                    <div class="premiumInfoSubText  secondaryText esmh-14">
                      <Trans i18nKey="premiumTextSuper">
                        Giving a Super like is a way to tell someone that you're
                        especially interested in them
                      </Trans>
                    </div>
                  </div>
                  <Swiper {...params2}>
                    {this.state.superlikeItems.map((item, index) => (
                      <div
                        className={
                          this.state.activeItem === item.id
                            ? "navigation--active"
                            : ""
                        }
                        onClick={this.handleSuperlikeItemClick.bind(
                          this,
                          item.id
                        )}
                        alt={item.id}
                        value={item.id}
                      >
                        <div className="premiumPrice">
                          <div className="apd10 daysPrice">
                            <div className="bold-font apk-30">
                              {item.superlike_count}
                            </div>
                            <div className="bold-font apk-20 mt-n2">
                              {item.superlike_count === 1 ? (
                                <Trans i18nKey="Super like">Super like</Trans>
                              ) : (
                                <Trans i18nKey="Super likes">Super likes</Trans>
                              )}{" "}
                            </div>
                          </div>
                          <div className="apd5 apk-16 mini-price">
                            {this.state.currency}
                            {item.price}
                          </div>
                        </div>
                      </div>
                    ))}
                  </Swiper>

                  <ul class="ubp-ul text-center justify-content-end amt20">
                    <li class="in-flex">
                      <button
                        onClick={this.closeModall.bind(this, "modal6")}
                        class="btn-block amgAuto border-0 bg-white"
                      >
                        <Trans i18nKey="Cancel">Cancel</Trans>
                      </button>
                    </li>
                    <li class="in-flex">
                      <NavLink
                        to={{
                          pathname: "/app/WalletPayment",
                          paytype: { type: "superlike" },
                        }}
                      >
                        {" "}
                        <button class="btn-block amgAuto border-0 bg-white pink-color">
                          <Trans i18nKey="Continue">Continue</Trans>{" "}
                        </button>
                      </NavLink>
                    </li>
                  </ul>
                  {/* <div className="sidebarLastContent text-center">
                                            
                                            <NavLink to={{
                                                pathname:'/app/WalletPayment',
                                            paytype: {type:'superlike'} 
                                            }}>  <button className="btn-common btn-block"><Trans i18nKey="Continue">Continue</Trans></button></NavLink> 

                                        </div> */}
                </div>
              ) : (
                <div className="premiumPopPlans text-center">
                  {" "}
                  <Trans i18nKey="No Plans Available">
                    {" "}
                    No Plans Available
                  </Trans>{" "}
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.referred_login_msg_modal}
          toggle={this.closeModal.bind(this, "referred_login_msg_modal")}
          className="premiumPopup vertically-center apd5"
        >
          {this.state.langKey == "ar" ? (
            <ModalHeader
              toggle={this.closeModal.bind(this, "referred_login_msg_modal")}
            >
              <h4
                class="modal-title"
                style={{ marginTop: "10px", direction: "ltr" }}
              >
                <Trans i18nKey={this.state.referred_login_message}>
                  {this.state.referred_login_message}
                </Trans>
              </h4>
            </ModalHeader>
          ) : (
            <ModalHeader
              toggle={this.closeModal.bind(this, "referred_login_msg_modal")}
            >
              <h4 class="modal-title" style={{ marginTop: "10px" }}>
                <Trans i18nKey={this.state.referred_login_message}>
                  {this.state.referred_login_message}
                </Trans>
              </h4>
            </ModalHeader>
          )}
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={this.closeModal.bind(
                      this,
                      "referred_login_msg_modal"
                    )}
                  >
                    <Trans i18nKey="Ok">Ok</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.free_premium_enabled}
          toggle={this.closeModal.bind(this, "free_premium_enabled")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader
            toggle={this.closeModal.bind(this, "free_premium_enabled")}
          >
            {this.state.langKey == "ar" ? (
              <>
                {" "}
                <h4 class="modal-title">
                  {this.state.free_premium_days == 1 ? (
                    <>
                      {" "}
                      <Trans i18nKey="Congratulations! you've got free premium activity for">
                        Congratulations! you've got free premium activity for
                      </Trans>{" "}
                      {this.state.free_premium_days}{" "}
                      <Trans i18nKey="day">day</Trans>{" "}
                    </>
                  ) : (
                    <>
                      {" "}
                      <Trans i18nKey="Congratulations! you've got free premium activity for">
                        Congratulations! you've got free premium activity for
                      </Trans>{" "}
                      {this.state.free_premium_days}{" "}
                      <Trans i18nKey="Days">days</Trans>{" "}
                    </>
                  )}
                </h4>
              </>
            ) : (
              <>
                {" "}
                <h4 class="modal-title" style={{marginTop:"20px",marginBottom:"20px"}}>
                <Trans i18nKey="Congratulations! you've got free premium activity for">
                    Congratulations! you've got free premium activity for
                  </Trans>{" "}
                  {this.state.free_premium_days} 
                  {this.state.free_premium_days == 1 ? (
                    <Trans i18nKey="day">day</Trans>
                  ) : (
                    <Trans i18nKey="days">days</Trans>
                  )}{" "}.
                 
                </h4>
              </>
            )}
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  {
                    <button
                      class="border-0 bg-white pink-color"
                      onClick={this.closeModal.bind(
                        this,
                        "free_premium_enabled"
                      )}
                    >
                      <Trans i18nKey="Ok">Ok</Trans>
                    </button>
                  }
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        {/* match Popup  */}

        {/* Premium Popup  */}
        <Modal
          isOpen={this.state.modal10}
          toggle={this.closeModal.bind(this, "modal10")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal10")}>
            <h4 class="modal-title">
              <Trans i18nKey="Join Premium">Join Premium</Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="premiumPop">
              <div className="premiumImgs">
                <Swiper {...params} shouldSwiperUpdate>
                  {this.state.permium_superlikeCount > 0 ? (
                    <div>
                      <div className="premiumImgHolder">
                        <img
                          src={require("../../assets/img/sub_superlike.png")}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <div className="premiumInfoHolder">
                        <div className="bold-font">
                          <Trans i18nKey="Get">Get</Trans>{" "}
                          {this.state.permium_superlikeCount}{" "}
                          <Trans i18nKey="free super likes">
                            free super likes
                          </Trans>
                        </div>
                        <div className="premiumInfoSubText  secondaryText esmh-14 ">
                          <Trans i18nKey="premiumTextSuper">
                            Giving a Super like is a way to tell someone that
                            you're especially interested in them
                          </Trans>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.state.permium_boostCount > 0 ? (
                    <div>
                      <div className="premiumImgHolder">
                        <img
                          src={require("../../assets/img/sub_boost.png")}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <div className="premiumInfoHolder">
                        <div className="bold-font">
                          <Trans i18nKey="Get">Get</Trans>{" "}
                          {this.state.permium_boostCount}{" "}
                          <Trans i18nKey="free boost">free boost</Trans>
                        </div>
                        <div className="premiumInfoSubText  secondaryText esmh-14 ">
                          <Trans i18nKey="premiumTextBoost">
                            Be the top profile in your area for 30minutes to get
                            more matches, Keep Swipe right!
                          </Trans>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_location.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Change Location">Change Location</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextLocation">
                          Get match and chat with others around the world by
                          simply searching for a city
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_morelike.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Unlimited Likes">Unlimited Likes</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextUnlimited">
                          Feel special again with 'Unlimited Likes'. Swipe right
                          as much as you want!
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sud_add.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Rewind">Rewind</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextRewind">
                          Accidentally swiped on someone? Rewind lets you take
                          back your last Like or Nope
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_morelike2.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Unlimited Liked">
                          Find out who likes you
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextUnlimiteds">
                          This feature allows you to see who has liked you!
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_profile.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Control your profile">
                          Control your profile
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextProfile">
                          Limit what others see and make parts of your profile
                          information invisible to other people
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_visited.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Visitors">
                          See who visited your profile
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextVisited">
                          A Visitors feature lets you see who looked at your
                          profile or ‘visited’ your profile
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sud_add2.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Turn Off Ads">Turn Off Ads</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextAds">
                          Have fun swiping with uninterrupted ads
                        </Trans>
                      </div>
                    </div>
                  </div>
                </Swiper>
              </div>

              <Countdown
                startdate={this.state.start_date}
                enddate={this.state.end_date}
              ></Countdown>

              <div className="premiumPopPlans">
                <Swiper {...params2}>
                  {this.state.itemss.map((item, index) => (
                    <div
                      className={
                        this.state.activeItems === item.id
                          ? "navigation--active"
                          : ""
                      }
                      onClick={this.handleItemClick.bind(this, item.id)}
                      alt={item.id}
                      value={item.id}
                    >
                      <div className="premiumPrice">
                        <div className="apd10 daysPrice">
                          <div className="bold-font apk-30">{item.days}</div>
                          <div className=" bold-font apk-24 mt-n2">
                            <Trans i18nKey={item.type}>{item.type}</Trans>
                          </div>
                        </div>
                        <div className="apd5 apk-16 mini-price">
                          {this.state.currency}
                          {item.price}
                        </div>
                      </div>
                    </div>
                  ))}
                </Swiper>
              </div>

              {/* <div className="sidebarLastContent text-center">
                            <NavLink to={{
                                pathname:'/app/WalletPayment',
                                paytype: {type:'premium'} 
                            }}>  <button className="btn-common btn-block"><Trans i18nKey="Continue">Continue</Trans></button></NavLink>
                            </div> */}

              <ul class="ubp-ul text-center justify-content-end amt20">
                <li class="in-flex">
                  <button
                    class="btn-block amgAuto border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal10")}
                  >
                    <Trans i18nKey="Cancel">Cancel</Trans>
                  </button>
                </li>
                <li class="in-flex">
                  <NavLink
                    to={{
                      pathname: "/app/WalletPayment",
                      paytype: { type: "premium" },
                    }}
                  >
                    {" "}
                    <button class="btn-block amgAuto border-0 bg-white pink-color">
                      <Trans i18nKey="Continue">Continue</Trans>{" "}
                    </button>
                  </NavLink>
                </li>
              </ul>
            </div>
          </ModalBody>
        </Modal>

        {/* match Popup  */}

        <Modal
          isOpen={this.state.modal11}
          toggle={this.closeModal.bind(this, "modal11")}
          className="modal-dialog premiumPopup matchPopup vertically-center apd5 newGradiantPopup"
        >
          {this.state.gif == "yes" ? (
            <Confetti
              recycle={false}
              style={{ flex: 1, zIndex: 99999, position: "fixed" }}
            />
          ) : (
            ""
          )}
          <ModalBody>
            <div className="modal-content">
              <div className="match-body">
                <div className="justify-content-end text-center matchContent">
                  <Trans i18nKey="It's a Match">It's a Match</Trans>
                </div>
                <div className="justify-content-end text-center matchContentSub">
                  You and {this.state.followername} like eatch other
                </div>
                <div
                  className="modal-images media"
                  style={{
                    position: "relative",
                    justifyContent: "center",
                    margin: "15px 0 10px 0",
                  }}
                >
                  <div className="matchmedia">
                    <img src={this.state.userprofile} alt="" className />
                  </div>
                  <div
                    className="matchlike"
                    style={{ top: "unset !important", bottom: "5px" }}
                  />
                  <div className="matchmedia">
                    <img src={this.state.followerprofile} alt="" className />
                  </div>
                </div>
                <div className="justify-content-end text-center">
                  <button
                    className="bg-white pink-color matchButton"
                    onClick={this.message}
                  >
                    <Trans i18nKey="Send message">Send message</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal12}
          toggle={this.closeModal.bind(this, "modal12")}
          className="modal-dialog premiumPopup matchPopup vertically-center apd5 newGradiantPopup"
        >
          <ModalBody>
            <div className="modal-content">
              <div className="match-body">
                <div
                  className="justify-content-end text-center matchContent"
                  id="matchid"
                >
                  <Trans i18nKey="Unlock to Match">Unlock to Match</Trans>
                </div>

                <div
                  className="modal-images media"
                  style={{
                    position: "relative",
                    justifyContent: "center",
                    margin: "15px 0 10px 0",
                  }}
                >
                  <div className="matchmedia">
                    <img src={this.state.userprofile} alt="" className />
                  </div>
                  <div
                    className="matchlike"
                    style={{ top: "unset !important", bottom: "5px" }}
                  />
                  <div className="matchmedia">
                    <img src={this.state.followerprofile} alt="" className />
                  </div>
                </div>
                <div className="justify-content-end text-center">
                  <button
                    className="bg-white pink-color matchButton"
                    onClick={this.showModal.bind(this, "modal15")}
                  >
                    <Trans i18nKey="Unlock">Unlock</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          backdrop="static"
          isOpen={this.state.modal13}
          toggle={this.closeModal.bind(this, "modal13")}
          className="modal-dialog premiumPopup matchPopup vertically-center apd5 newGradiantPopup"
        >
          <ModalBody>
            <div className="modal-content">
              <div className="match-body">
                <div
                  className="justify-content-end text-center matchContent"
                  id="matchids"
                >
                  {this.state.user_details.premium_member === "true" ? (
                    <Trans i18nKey="Matches Pending">Matches Pending</Trans>
                  ) : (
                    <Trans i18nKey="Match Pending">Match Pending</Trans>
                  )}
                </div>

                <div
                  className="modal-images media"
                  style={{
                    position: "relative",
                    justifyContent: "center",
                    margin: "15px 0 10px 0",
                  }}
                >
                  <div className="matchmedia">
                    <img src={this.state.userprofile} alt="" className />
                  </div>
                  <div
                    className="matchlike"
                    style={{ top: "unset !important", bottom: "5px" }}
                  />
                  <div className="matchmedia">
                    <img src={this.state.followerprofile} alt="" className />
                  </div>
                </div>
                <div className="justify-content-end text-center">
                  <button
                    className="bg-white pink-color matchButton"
                    onClick={this.closeModal.bind(this, "modal13")}
                  >
                    <Trans i18nKey="Ok">Ok</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal15}
          toggle={this.closeModal.bind(this, "modal15")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal15")}>
            <h4 class="modal-title">
              <Trans i18nKey="Join Premium">Join Premium</Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="premiumPop">
              <div className="premiumImgs">
                <Swiper {...params} shouldSwiperUpdate>
                  {this.state.permium_superlikeCount > 0 ? (
                    <div>
                      <div className="premiumImgHolder">
                        <img
                          src={require("../../assets/img/sub_superlike.png")}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <div className="premiumInfoHolder">
                        <div className="bold-font">
                          <Trans i18nKey="Get">Get</Trans>{" "}
                          {this.state.permium_superlikeCount}{" "}
                          <Trans i18nKey="free super likes">
                            free super likes
                          </Trans>
                        </div>
                        <div className="premiumInfoSubText  secondaryText esmh-14 ">
                          <Trans i18nKey="premiumTextSuper">
                            Giving a Super like is a way to tell someone that
                            you're especially interested in them
                          </Trans>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.state.permium_boostCount > 0 ? (
                    <div>
                      <div className="premiumImgHolder">
                        <img
                          src={require("../../assets/img/sub_boost.png")}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <div className="premiumInfoHolder">
                        <div className="bold-font">
                          <Trans i18nKey="Get">Get</Trans>{" "}
                          {this.state.permium_boostCount}{" "}
                          <Trans i18nKey="free boost">free boost</Trans>
                        </div>
                        <div className="premiumInfoSubText  secondaryText esmh-14 ">
                          <Trans i18nKey="premiumTextBoost">
                            Be the top profile in your area for 30minutes to get
                            more matches, Keep Swipe right!
                          </Trans>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_location.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Change Location">Change Location</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextLocation">
                          Get match and chat with others around the world by
                          simply searching for a city
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_morelike.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Unlimited Likes">Unlimited Likes</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextUnlimited">
                          Feel special again with 'Unlimited Likes'. Swipe right
                          as much as you want!
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sud_add.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Rewind">Rewind</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextRewind">
                          Accidentally swiped on someone? Rewind lets you take
                          back your last Like or Nope
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_morelike2.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Unlimited Liked">
                          Find out who likes you
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextUnlimiteds">
                          This feature allows you to see who has liked you!
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_profile.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Control your profile">
                          Control your profile
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextProfile">
                          Limit what others see and make parts of your profile
                          information invisible to other people
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_visited.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Visitors">
                          See who visited your profile
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextVisited">
                          A Visitors feature lets you see who looked at your
                          profile or ‘visited’ your profile
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sud_add2.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Turn Off Ads">Turn Off Ads</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextAds">
                          Have fun swiping with uninterrupted ads
                        </Trans>
                      </div>
                    </div>
                  </div>
                </Swiper>
              </div>

              {this.state.timer_status == 1 ? (
                <Countdown
                  startdate={this.state.start_date}
                  enddate={this.state.end_date}
                ></Countdown>
              ) : (
                ""
              )}

              <div className="premiumPopPlans">
                <Swiper {...params2}>
                  {this.state.itemss.map((item, index) => (
                    <div
                      className={
                        this.state.activeItems === item.id
                          ? "navigation--active"
                          : ""
                      }
                      onClick={this.handleItemClick.bind(this, item.id)}
                      alt={item.id}
                      value={item.id}
                    >
                      <div className="premiumPrice">
                        <div className="apd10 daysPrice">
                          <div className="bold-font apk-30">{item.days}</div>
                          <div className=" bold-font apk-24 mt-n2">
                            <Trans i18nKey={item.type}>{item.type}</Trans>
                          </div>
                        </div>
                        <div className="apd5 apk-16 mini-price">
                          {this.state.currency}
                          {item.price}
                        </div>
                      </div>
                    </div>
                  ))}
                </Swiper>
              </div>

              {/* <div className="sidebarLastContent text-center">
                            <NavLink to={{
                                pathname:'/app/WalletPayment',
                                paytype: {type:'premium'} 
                            }}>  <button className="btn-common btn-block"><Trans i18nKey="Continue">Continue</Trans></button></NavLink>
                            </div> */}

              <ul class="ubp-ul text-center justify-content-end amt20">
                <li class="in-flex">
                  <button
                    class="btn-block amgAuto border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal15")}
                  >
                    <Trans i18nKey="Cancel">Cancel</Trans>
                  </button>
                </li>
                <li class="in-flex">
                  <NavLink
                    to={{
                      pathname: "/app/WalletPayment",
                      paytype: { type: "premium" },
                    }}
                  >
                    {" "}
                    <button class="btn-block amgAuto border-0 bg-white pink-color">
                      <Trans i18nKey="Continue">Continue</Trans>{" "}
                    </button>
                  </NavLink>
                </li>
              </ul>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.premmodal4}
          toggle={this.closeModall.bind(this, "premmodal4")}
          className="premiumBenifit vertically-center apd5 mt-3 mt-md-0"
        >
          <ModalHeader toggle={this.closeModall.bind(this, "premmodal4")}>
            <div className="amtN45 relPos">
              <img
                src={this.state.user_details.images}
                alt=""
                className="premiumBDP"
              />
              <div class="preIcon"></div>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="premiumBenifitPopup">
              <div className="mb-4">
                <div className="apk-24 pink-color text-center bold-font">
                  <Trans i18nKey="A new way to date">A new way to date</Trans>!
                </div>
                <div className="apk-20 text-center bold-font">
                  <Trans i18nKey="The most secure way of dating">
                    The most secure way of dating
                  </Trans>
                  .
                </div>
                {this.state.isrevealed && (
                  <div className="apk-20 text-center bold-font">
                    <Trans
                      i18nKey="Congratulations! you have got a
few new matches"
                    >
                      Congratulations! you have got a few new matches
                    </Trans>
                    .
                  </div>
                )}
              </div>
              <div className="premiumBenifitOverflow">
                <div className="form-group">
                  <div className="apk-22 d-flex">
                    {" "}
                    <div class="tickIco mr-2"></div>{" "}
                    <Trans i18nKey="Unlimited likes">Unlimited likes</Trans>
                  </div>
                  <div className="aml35">
                    <Trans i18nKey="premiumText">
                      Includes this striking feature that allows users to change
                      their location and search for new matches or people who
                      live in another area.
                    </Trans>
                  </div>
                </div>
                <div className="form-group">
                  <div className="apk-22 d-flex">
                    {" "}
                    <div class="tickIco mr-2"></div>{" "}
                    <Trans i18nKey="Meet someone interesting">
                      Meet someone interesting
                    </Trans>
                  </div>
                  <div className="aml35">
                    <Trans i18nKey="premiumText5">
                      Includes this striking feature that allows users to change
                      their location and search for new matches or people who
                      live in another area.
                    </Trans>
                  </div>
                </div>
                <div className="form-group">
                  <div className="apk-22 d-flex">
                    {" "}
                    <div class="tickIco mr-2"></div>{" "}
                    <Trans i18nKey="Go inginito">Go inginito</Trans>
                  </div>
                  <div className="aml35">
                    <Trans i18nKey="premiumText6">
                      Includes this striking feature that allows users to change
                      their location and search for new matches or people who
                      live in another area.
                    </Trans>
                  </div>
                </div>
                <div className="form-group">
                  <div className="apk-22 d-flex">
                    {" "}
                    <div class="tickIco mr-2"></div>{" "}
                    <Trans i18nKey="Hide your age">Hide your age</Trans>
                  </div>
                  <div className="aml35">
                    <Trans i18nKey="premiumText7">
                      Includes this striking feature that allows users to change
                      their location and search for new matches or people who
                      live in another area.
                    </Trans>
                  </div>
                </div>
                <div className="form-group">
                  <div className="apk-22 d-flex">
                    {" "}
                    <div class="tickIco mr-2"></div>
                    <Trans i18nKey="No ads">No ads</Trans>
                  </div>
                  <div className="aml35">
                    <Trans i18nKey="premiumText8">
                      Includes this striking feature that allows users to change
                      their location and search for new matches or people who
                      live in another area.
                    </Trans>
                  </div>
                </div>
                <div className="form-group">
                  <div className="apk-22 d-flex">
                    {" "}
                    <div class="tickIco mr-2"></div>
                    <Trans i18nKey="premiumText9">New Feature</Trans>
                  </div>
                </div>
              </div>
              <div class="apd10 text-center">
                <button
                  class="border-0 pink-color white-bg text-center apk-24"
                  onClick={this.closeModall.bind(this, "premmodal4")}
                >
                  <Trans i18nKey="Continue">Continue</Trans>
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.modal22}
          toggle={this.homeLink}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.homeLink}>
            <h4 class="modal-title" style={{ marginTop: "10px" }}>
              <Trans i18nKey={this.state.message}>{this.state.message}</Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="justify-content-center">
                <h5>
                  <Trans
                    i18nKey={
                      "In the event of a payment problem, please contact the SATIM toll-free number 3020."
                    }
                  >
                    In the event of a payment problem, please contact the SATIM
                    toll-free number 3020.
                  </Trans>
                </h5>
              </div>
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={this.homeLink}
                  >
                    <Trans i18nKey="Ok">Ok</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <div className={this.state.suc_msg}>
          <Trans i18nKey={this.state.alert_msg}>{this.state.alert_msg}</Trans>
        </div>

        <div class="footerSection">{/* <Footer /> */}</div>
      </div>
    );
  }
}

export default withTranslation("translations")(PeopleNear);
